import classnames from "classnames";
import React from "react";

interface ImageProps extends React.ComponentPropsWithoutRef<"img"> {
  invert?: boolean;
}

const Image: React.FunctionComponent<ImageProps> = ({
  className,
  src,
  invert = false,
  width,
  height,
  alt,
  ...props
}) => (
  <img
    {...props}
    className={classnames(className, invert && "img-invert")}
    src={src}
    width={width}
    height={height}
    alt={alt}
  />
);

export default Image;
